import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const ExcoVideoWrapperAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "ExcoVideoWrapper" */ './exco-video-wrapper'),
  componentName: 'ExcoVideoWrapper',
});
